import { createSearchParams } from "react-router-dom";
import {
  AGENT_MANAGEMENT_SERVICE_CONSTANTS,
  AGENT_MANAGEMENT_TYPE_QUERY_PARAM,
} from "../../core/constants/agentManagements.constants";
import { CifCupsAgent } from "../../core/models/cupsCifSelector/cupsCifSelector.model";
import { OwnerData } from "../../core/models/ownerData/ownerData.model";

export function mapAgentMasterResponseToOwnerData(
  cupList: CifCupsAgent[],
): OwnerData {
  return {
    CUPS: cupList.map((cup) => ({
      Aclarador: "",
      Calle: cup.Calle,
      Ciudad: "",
      CodigoContrato: "",
      CodigoCups: cup.Cups,
      Entorno: cup.Contratos[0]?.Entorno || "",
      EntornoBD: "",
      IdContrato: cup.Contratos[0]?.IdContrato.toString() || "",
      IdCups: cup.IdCups.toString(),
      IdPerfilFacturacion: "",
      IdTarifa: "",
      IdTarifaGrupo: "",
      IdentidadTitular: cup.Contratos[0]?.Identidad || "",
      IdContratoSituacion: 0,
      Municipio: "",
      Numero: cup.Numero ? cup.Numero.toString() : "",
      PerfilFacturacion: "",
      Provincia: "",
      Tarifa: "",
      TarifaGrupo: "",
      TipoVia: "",
      RazonSocial: "",
      FechaAlta: "",
    })),
    DatosDireccion: {
      DireccionCliente: "",
      CiudadCliente: "",
      CodigoPostalCliente: "",
      MunicipioCliente: "",
      ProvinciaCliente: "",
      IdCallejeroCliente: "",
      IdCiudadCliente: "",
    },
    DatosPersonales: {
      Apellido1Cliente: "",
      Apellido2Cliente: "",
      NombreCliente: "",
      NombreRepresentante: "",
      RazonSocialCliente: "",
      IdentificadorClienteDNI: "",
      IdentificadorClienteEmail: "",
      IdCliente: "",
      IdColectivoRepresentante: "",
      IdentificadorRepresentante: "",
      ColectivoCliente: "",
      ColectivoRepresentante: "",
      ComentarioRepresentante: "",
    },
    flags: {
      EsCliente: false,
      EsAdministrador: false,
      EsConsultor: false,
      EsConsultorVirtual: false,
      EsUsuario: false,
      EsAgente: true,
      EsApiAdmin: false,
    },
    DatosAdministrador: {
      DireccionAdministrador: "",
      EmailAdministrador: "",
      IdAdministrador: "",
      MovilAdministrador: "",
      NombreAdministrador: "",
      NotasAdministrador: "",
      TelefonoAdministrador: "",
      WebAdministrador: "",
      CiudadAdministrador: "",
      CodigoPostalAdministrador: "",
      NumeroEntidades: "",
    },
    IsAdministrador: false,
    NumeroSuministros: "",
  };
}

export const getAgentManagementUrl = (
  typeQuery: keyof typeof AGENT_MANAGEMENT_SERVICE_CONSTANTS,
): string =>
  `${process.env.REACT_APP_MANAGEMENT_AGENT_PAGE}?${createSearchParams({
    [AGENT_MANAGEMENT_TYPE_QUERY_PARAM]: typeQuery,
  })}`;
